<template>
  <div>
    <template v-if="checkCurrentPage">
      <b-form-select
        :value="selectedUserSoleProprietorship"
        :options="userSoleProprietorshipOptions"
        @change="onSelectionChange"
        :selected="selectedUserSoleProprietorshipDropdown"
        v-if="userSoleProprietorshipOptions"
        class="custom-select"
        style="width: 100% !important"
        :disabled="disableSelector"
      ></b-form-select>
    </template>
    <template v-else>
      <b-row>
        <b-col lg="9" sm="12">
          <b-form-select
            :value="selectedUserSoleProprietorship"
            :options="userSoleProprietorshipOptions"
            @change="onSelectionChange"
            :selected="selectedUserSoleProprietorshipDropdown"
            class="custom-select select-home"
            style="width: 100% !important"
            v-if="userSoleProprietorshipOptions"
            :disabled="disableSelector"
          ></b-form-select>
        </b-col>
        <b-col lg="3" sm="12">
          <b-button
            type="submit"
            variant="primary"
            @click.prevent="onUserSoleProprietorshipCheck"
            :disabled="isLoading"
            class="next-button mt-2 mt-lg-0"
          >
            <b-spinner small v-if="isLoading"></b-spinner>
            <span class="sr-only" v-if="isLoading">Betöltés...</span>
            <span v-if="!isLoading">Megtekintés</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SelectSoleProprietorship',
  props: {
    currentPage: String,
    disableSelector: {
      type: Boolean,
      default: false
    }
  },
  async created() {
    if (this.userSoleProprietorships[0] && !this.selectedUserSoleProprietorship) {
      this.$store.commit('setSelectedUserSoleProprietorship', this.userSoleProprietorships[0])
    }
  },
  async mounted() {
    if (!this.userSoleProprietorshipOptions.length) await this.$store.dispatch('getUserSoleProprietorships', {})

    if (this.userSoleProprietorships[0] && !this.selectedUserSoleProprietorship) {
      this.$store.commit('setSelectedUserSoleProprietorship', this.userSoleProprietorships[0])
      this.$store.commit('setSelectedSoleProprietorship', this.userSoleProprietorships[0].soleProprietorshipData)
    }

    const soleProprietorshipId = this.selectedSoleProprietorship?.flaggerId ?? null

    if (!this.selectedUserSoleProprietorship && !soleProprietorshipId) {
      // there is no selected userSoleProprietorship, selelect the first one
      this.$store.commit('setSelectedUserSoleProprietorship', this.selectedUserSoleProprietorship)
      this.$store.commit('setSelectedSoleProprietorship', this.selectedUserSoleProprietorship.soleProprietorshipData)
    }
    if (soleProprietorshipId) {
      const userAssignedSoleProprietorship = this.userSoleProprietorships.filter(function(userSoleProprietorship) {
        return userSoleProprietorship.soleProprietorshipId == soleProprietorshipId
      })
      if (userAssignedSoleProprietorship[0]) {
        this.$store.commit('setSelectedUserSoleProprietorship', userAssignedSoleProprietorship[0])
      } else {
        this.$store.commit('setSelectedUserSoleProprietorship', this.userSoleProprietorships[0])
      }
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'userSoleProprietorshipOptions',
      'selectedUserSoleProprietorship',
      'userSoleProprietorships',
      'selectedSoleProprietorship'
    ]),
    checkCurrentPage() {
      return this.$router.currentRoute.fullPath == '/sole-proprietorship-offers-private' ||
        this.$router.currentRoute.path == '/kkv-result'
        ? true
        : false
    },
    currentPageKkvQualifier() {
      return this.currentPage == 'kkv-qualifier' || this.currentPage?.includes('kkv-result') ? true : false
    },
    selectedUserSoleProprietorshipDropdown() {
      if (this.selectedUserSoleProprietorship != null && this.userSoleProprietorshipOptions != null) {
        const selectedOption = this.userSoleProprietorshipOptions.filter(
          t => t.value.soleProprietorshipId == this.selectedUserSoleProprietorship.soleProprietorshipId
        )
        if (selectedOption.length >= 1) return this.selectedUserSoleProprietorship.value
        else return null
      } else return null
    }
  },
  methods: {
    async applySelectedSoleProprietorship() {
      if (this.$router.currentRoute.fullPath == '/sole-proprietorship-offers-private') {
        await this.$store.dispatch('getCompetitionsSoleProprietorship', {
          soleProprietorshipId: this.selectedUserSoleProprietorship.soleProprietorshipId
        })
      }
      if (this.$router.currentRoute.fullPath == '/home') {
        const getSoleProprietorshipQueryParams = {
          value: this.selectedUserSoleProprietorship.soleProprietorshipId
        }
        await this.$store.dispatch('getSoleProprietorship', getSoleProprietorshipQueryParams)
      }
      if (this.$router.currentRoute.name == 'Result') {
        this.$emit('onSelectionChange', this.selectedUserSoleProprietorship.soleProprietorshipId)
      }
    },
    async onUserSoleProprietorshipCheck() {
      if (!this.selectedUserSoleProprietorship)
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'Nincs kiválasztva cég.' }
        })
      else {
        if (this.$router.currentRoute.fullPath == '/home' && !this.selectedSoleProprietorship) {
          const getSoleProprietorshipQueryParams = {
            value: this.selectedUserSoleProprietorship.soleProprietorshipId
          }
          await this.$store.dispatch('getSoleProprietorship', getSoleProprietorshipQueryParams)
        }
        await this.applySelectedSoleProprietorship()
        // snippet below handles the rest occasions on component mounted
        // only change route when user is not on that page
        if (this.$router.currentRoute.fullPath != '/sole-proprietorship-offers-private') {
          this.$router.push({
            name: 'SoleProprietorshipDetails',
            query: { soleProprietorshipId: this.selectedUserSoleProprietorship.soleProprietorshipId }
          })
        }
      }
    },
    async onSelectionChange(selectedUserSoleProprietorship) {
      if (this.$router.currentRoute.fullPath == '/home') {
        const getSoleProprietorshipQueryParams = {
          value: selectedUserSoleProprietorship.soleProprietorshipId
        }
        await this.$store.dispatch('getSoleProprietorship', getSoleProprietorshipQueryParams)
      }
      this.$store.commit('setSelectedUserSoleProprietorship', selectedUserSoleProprietorship)
      this.$store.commit('setSelectedSoleProprietorship', selectedUserSoleProprietorship.soleProprietorshipData) // TODO
      await this.applySelectedSoleProprietorship()
    }
  }
}
</script>

<style scoped>
.next-button {
  height: 80px;
  font-size: 24px;
  width: 100%;
}

@media screen and (min-width: 990px) {
  .next-button {
    width: max-content;
  }
}

#search-input {
  border-radius: 10px;
  color: var(--color-green);
  padding: 20px;
  border-color: var(--color-green) !important;
  border: 2px solid !important;
}

select,
option,
.custom-select {
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  width: 100% !important;
  border-radius: 8px !important;
  color: var(--color-gray-04) !important;
  background-size: 12px !important;
  height: 48px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #dfe6e9;
}

.select-home {
  min-height: 80px !important;
  font-size: 24px;
  background-size: 24px !important;
}

.kkvCustomSelect select,
.kkvCustomSelect option,
.kkvCustomSelect {
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  width: 100% !important;
  color: white;
  background-color: #00903c !important;
  border: 2px solid white !important;
  border-radius: 5px !important;
  min-height: 3rem;
}

.kkvCustomButton {
  border: 2px solid white !important;
}

.search-input-icon {
  border-bottom-right-radius: 15px;
  border-top-right-radius: 15px;
}

form {
  max-width: 100%;
}
</style>
